const addeoTeam = ['RA', 'CB', 'BC', 'LD', 'GV']

import * as TerrassorConst from '../../terrassor_const.js'

/*
  constructor(ApiConst, ApiSimu, ApiExo, TerrassorDB, $location, $filter, $q) {
    this.$q = $q;
 */

/* @ngInject */
export class HomepageController {
  /* @ngInject */
  constructor ($q) {
    this.maxLength = 5;
    this.baseline = `Hey I'm a controller associated to a Component`
    this.data = addeoTeam
    this.collection = this.data.filter(word => word.length <= this.maxLength);

    /*ApiEngins.getEngins()
    .then(result => {
      this.engins = result
    })

    ApiCubatureTypes.getAllCubatureTypes()
    .then(result => {
      this.cubatureTypes = result
    })*/

    this.$q = $q;

    this.securiteOK = TerrassorConst.SECURITE_VALIDE;
    if (TerrassorConst.SECURITE_VALIDE) {
        $("#demarrer").removeClass("cacher");
    }
    this.isWeb = TerrassorConst.IS_WEB;
    //this.ticketErrone=0;

  }



  // methode publique et utilisable depuis la vue
  increaseMaxLength() {
    this.maxLength++;
    this.collection = this.data.filter(word => word.length <= this.maxLength);
  }

  // methode publique et utilisable depuis la vue
  decreaseMaxLength() {
    this.maxLength--;
    this.collection = this.data.filter(word => word.length <= this.maxLength);
  }

  cacherCredits() {
      $( "#credits" ).removeClass( "montrer" );
  }
  montrerCredits() {
      $( "#credits" ).addClass( "montrer" );
  }

    validerTicket() {
        var leController = this;
        var ticket = $( "#idInputSecuriteOK" ).val();
        jQuery.ajax({
            type: "POST",
//            url: "external/php/tmpValidationTicket.php?ticket="+ticket,
            url: "https://admin.terrassor.fr/api/tickets/autorisation/"+ticket+".json",
            dataType: 'json',
            success: function(res){
            if (res.retour && res.retour.ok > 0) {
                    TerrassorConst.SECURITE_VALIDE = 1;
                    //leController.securiteOK = TerrassorConst.SECURITE_VALIDE;
                    leController.ecrireTicket(ticket);
                    $("div.securiteOK").addClass("cacher");
                    $("#demarrer").removeClass("cacher");
                }
                else {
                    //leController.ticketErrone=1;
                    $("div.securiteOK span.attente").addClass("cacher")
                    $("div.securiteOK span.erreur").removeClass("cacher");
                }
            },
            error : function(res){
                //leController.ticketErrone=1;
                $("div.securiteOK span.attente").addClass("cacher")
                $("div.securiteOK span.erreur").removeClass("cacher");
            }
        });
    }

    ecrireTicket(ticket) {

        jQuery.ajax({
            type: "POST",
            url: "external/php/readTicket.php?ticket="+ticket, // on charge une étude - éventuellement vide
            dataType: 'json',
            success: function(res){
				    if (res.ok) {
                        // ecriture variable de session OK
                        //alert("ecrireTicket OK");
                        console.log('ecrireTicket, ticket écrit : ', ticket);
                    }
                    else {
                        // ecriture variable de session pas OK
                        //alert("ecrireTicket pas OK 1");
                        console.log('ecrireTicket, ticket pas écrit : ', ticket);
                    }

                },
            error : function(res){
                // ecriture variable de session pas OK
                //alert("ecrireTicket pas OK 2");
                        console.log('ecrireTicket, erreur : ', ticket);
                }
            });
        }



}

/*
- constructor() {} est appelé lors de l'instanciation du component.
- chaque propriété assignée sur `this` est publique et utilisable depuis la vue
- chaque methode d'instance est publique utilisable depuis la vue
*/

/*

    var request = window.indexedDB.deleteDatabase(TerrassorConst.DATABASE_NAME);
*/



// WEBPACK FOOTER //
// ./src/client/pages/homepage/homepage.controller.js